export default "__VITE_ASSET__BqkJvBUx__"